<script>
import {DateUtil} from '@/utils/date.js'
import dialog from '@/components/Dialog'
import showMap from '@/components/showMapWindowMask'
import mapDropPin from '../assets/map_icon/map_drop_pin.png'

export default {
  components: {'v-dialog': dialog, showMap},
  created () {
  },
  data () {
    return {
      startPlaceTitle: '出発地',
      arrivePlaceTitle: '終点地'
    }
  },
  props: {
    shift: {type: Object},
    shiftInfoList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    moveShiftTime: function () {
      return DateUtil.yyyyMMdd(this.shift.moveShiftTime)
    }
  },
  methods: {
    setOpenFlag () {
      var openFlag = this.shift.openFlag
      if (openFlag === 1) {
        openFlag = 0
      } else openFlag = 1
      this.shift.openFlag = openFlag
      for (let i = 0; i < this.shiftInfoList.length; i++) {
        let shiftInfo = this.shiftInfoList[i]
        if (this.shift.shiftId === shiftInfo.parentShiftId) {
          this.shiftInfoList[i].openFlag = openFlag
        }
      }
      this.$axios.post('shift/updateOpenFlag', this.shift)
        .then(response => {
          console.log()
          this.$emit('changeOpenFlag', openFlag)
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 地图显示自宅住址
    // マップ弹出场所地图
    map (homeLat, homeLng, homeAddress, title) {
      homeLat = parseFloat(homeLat)
      homeLng = parseFloat(homeLng)
      if (title === this.startPlaceTitle) {
        this.$refs.showMapWindow.mapTitle = '出発地: ' + homeAddress
      } else if (title === this.arrivePlaceTitle) {
        this.$refs.showMapWindow.mapTitle = '終点地：' + homeAddress
      }

      this.$refs.showMapWindow.mapId = 'home'
      // 图标样式
      let vehiclePoint = {
        lat: homeLat,
        lng: homeLng,
        icon: mapDropPin
      }
      var centerPoint = {
        lat: homeLat,
        lng: homeLng
      }
      this.$refs.showMapWindow.centerPoint = centerPoint
      this.$refs.showMapWindow.markPosition = vehiclePoint
      this.$refs.showMapWindow.initiGoogleMap()
    }
  }
}
</script>

<template>
  <div class="col-md-12 column">
    <div class="modal fade" id="modal-container-regular-detail" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
              <img height="30px" src="@/assets/X.png" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;" />
            </button>
            <p class="modal-title" id="myModalLabel" v-if="shift.openFlag === 0">
              [ {{shift.title}} ] 公開
            </p>
            <p class="modal-title" id="myModalLabel" v-else>
              [ {{shift.title}} ] 非公開
            </p>
          </div>
          <div class="modal-body slider">
            <table class="table table-bordered window-table">
              <tbody>
                <tr>
                  <td class="td-key">
                    便名
                  </td>
                  <td colspan="3" class="td-value tooLong">
                    {{shift.title}}
                  </td>
                </tr>
                <tr>
                  <td class="td-key">
                    便ID
                  </td>
                  <td colspan="3" class="td-value tooLong">
                    {{shift.shiftId}}
                  </td>
                </tr>
                <tr>
                  <td width='12%' class="td-key">
                    フリガナ
                  </td>
                  <td width='38%' class="td-value tooLong">
                    {{shift.driverNameKana}}
                  </td>
                  <td width='12%' class="td-key">
                    車両
                  </td>
                  <td width='38%' class="td-value tooLong F3-M-18">
                    <!-- <div class="flexReserveTime">
                      <span class="F3-M-18 tooLong" style="display: block;border:1px solid yellow">{{ shift.vehicleName }}</span>
                      <span class="F3-M-18" style="display: block;margin-left:10px;border:1px solid red;">ID:{{shift.vehicleId}}</span>
                      <span class="F3-M-18" style="display: block;margin-left:10px;border:1px solid blue;">定員{{shift.passengerNumber}}名</span>
                    </div> -->
                    {{ shift.vehicleName }}&nbsp;&nbsp;&nbsp;ID:{{shift.displayVehicleId}}&nbsp;&nbsp;&nbsp;定員 {{shift.passengerNumber}} 名
                  </td>
                </tr>
                <tr>
                  <td class="td-key">
                    ドライバー
                  </td>
                  <td colspan="3" class="td-value tooLong">
                    {{shift.driverName}}
                  </td>
                </tr>
                <tr>
                  <td class="td-key">
                    運行日
                  </td>
                  <td colspan="3" class="td-value tooLong">
                    {{(moveShiftTime)}}
                  </td>
                </tr>
                <tr>
                  <td class="td-key">
                    出発地
                  </td>
                  <td class="td-value tooLong">
                    {{shift.startPlace}}
                    <a href="#modal-container-staySave" data-toggle="modal">
                      <button class="mapbtn" @click="map(shift.startPlaceLat,shift.startPlaceLng,shift.startPlace,startPlaceTitle)">
                        マップ
                      </button>
                    </a>
                  </td>
                  <td class="td-key">
                    発車時間
                  </td>
                  <td class="td-value tooLong">
                    {{shift.startTime}}
                  </td>
                </tr>
                <tr>
                  <td class="td-key">
                    終点地
                  </td>
                  <td class="td-value tooLong">
                    {{shift.arrivePlace}}
                    <a href="#modal-container-staySave" data-toggle="modal">
                      <button class="mapbtn" @click="map(shift.arrivePlaceLat, shift.arrivePlaceLng, shift.arrivePlace, arrivePlaceTitle)">
                        マップ
                      </button>
                    </a>
                  </td>
                  <td class="td-key">
                    到着予定時間
                  </td>
                  <td class="td-value tooLong">
                    {{shift.arriveTime}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <b class="F1-M-24" v-if="shift.openFlag === 0">以上の内容で会員に公開しますか</b>
            <b class="F1-M-24" v-else>以上の内容で会員に非公開しますか</b>
          </div>
          <!-- button -->
          <div>
            <div class="row clearfix">
              <div class="col-md-6 column">
                <button class="window-button F2-M-24" style="float:right;" @click="setOpenFlag()" data-dismiss="modal">はい</button>
              </div>
              <div class="col-md-6 column">
                <button class="window-button F2-M-24" style="float:left;" data-dismiss="modal">いいえ</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <showMap ref="showMapWindow"></showMap>
  </div>
</template>

<style lang="scss" scoped>@import "../assets/css/C00.css";
@import '../assets/css/globalStyle02.scss';
.modal-dialog {
  top: 20%;
  width: 1200px;
  margin-top: -120px;
}

.modal-header {
  border-bottom: 0px;
}

.modal-title {
  font-size: 28px;
}

.modal-body {
  padding-left: 40px;
  padding-top: 0px;
  margin-right: 10px;
  height: 500px;
  overflow-x: hidden;
  overflow-y: auto;
}

.window-table {
  font-size: 18px;
  border: 1px solid #959595;
}

.table-bordered>tbody>tr>td {
  border: 1px solid #959595;
}

.td-title {
  background-color: #797979;
  color: #fff;
  font-size: 22px;
}

.td-key {
  // F3-R-15
  font-family: 'Noto Sans CJK JP';
  color: rgb(80, 80, 80);
  font-size: 15px;
  font-weight: 400;
  background: $bgc8
}

.table>tbody>tr>td {
  vertical-align: middle;
  padding: 9px;
}

.table>tbody>tr>.td-value {
  padding-left: 30px;
}

.td-value {
  text-align: left; // F3-M-18
  font-family: 'Noto Sans CJK JP';
  color: rgb(80, 80, 80);
  font-size: 18px;
  font-weight: 500;
  background: $bgc7
}

.window-button {
  width: 500px;
  height: 60px;
  border: none;
  border-radius: 10px;
  margin-top: 30px;
  margin-bottom: 30px;
  font-size: 2em;
  color: #fff;
  background-color: #717171;
}

.close {
  opacity: 1;
}

.mapbtn {
  height: 30px;
  width: 80px;
  font-size: 18px;
  background-color: #DDDDDD;
  border: none;
  border-radius: 4px;
  float: right;
  margin-right: 0.5%;
  color: black;
}

.flexReserveTime {
  display: flex;
  justify-content: flex-start;
}

.tooLong {
  word-wrap: break-word;
  word-break: break-all;
}

.member-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

// td {
//   vertical-align: middle
// }
</style>



// WEBPACK FOOTER //
// src/components/MovementShiftWindowMask.vue